import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { resetPassword } from "../../services/auth";
import "./css/login.css";

export default function ResetPassword() {
  const { token } = useParams();
  const navigate = useNavigate();

  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const submit = async () => {
    setError(null);

    if (password.length < 8) {
      setError("Lösenordet måste vara minst 8 tecken.");
      return;
    }
    if (password !== confirm) {
      setError("Lösenorden matchar inte.");
      return;
    }

    setSubmitting(true);
    try {
      await resetPassword(token, password);
      setDone(true);
    } catch (e) {
      setError(e.message || "Det gick inte att återställa lösenordet.");
    } finally {
      setSubmitting(false);
    }
  };

  if (done) {
    return (
      <div className="login-wrapper">
        <div className="login-card">
          <h1>Lösenordet är uppdaterat</h1>
          <p>Du kan nu logga in med ditt nya lösenord.</p>
          <button className="login-button" onClick={() => navigate("/login")}>
            Till inloggning
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="login-wrapper">
      <div className="login-card">
        <h1>Välj nytt lösenord</h1>

        <div className="login-field">
          <label>Nytt lösenord</label>
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
          />
        </div>

        <div className="login-field">
          <label>Bekräfta lösenord</label>
          <input
            type="password"
            value={confirm}
            onChange={(e) => setConfirm(e.target.value)}
            autoComplete="new-password"
          />
        </div>

        {error && <div className="login-error">{error}</div>}

        <button
          className="login-button"
          onClick={submit}
          disabled={submitting}
        >
          {submitting ? "Sparar…" : "Spara nytt lösenord"}
        </button>
      </div>
    </div>
  );
}
